import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { CountryModel } from './country.model'
import { environment } from '../../../../environments/environment'
import { catchError, map, Observable } from 'rxjs'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(private http: HttpClient) {}

  addCountry(country: CountryModel) {
    return this.http.post(API_URL + '/Country/CreateCountry', country, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateCountry(country: CountryModel) {
    
    return this.http.put(API_URL + '/Country/UpdateCountry', country, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllCountries(): Observable<CountryModel[]> {
    return this.http.get(API_URL + '/Country/ReadCountries', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  deleteCountry(country: CountryModel) {
    
    return this.http
      .delete(API_URL + '/Country/DeleteCountry', {
        headers: {},
        body: country,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
